import React from 'react';
import { FormField, FormLabel, FormSelect, FormInput, Button } from '../ui';
import { QrcodeFilters as QrcodeFiltersType } from '../../types/qrcode';
import { Search, X } from 'lucide-react';

interface QrcodeFiltersProps {
  filters: QrcodeFiltersType;
  onFilterChange: (filters: QrcodeFiltersType) => void;
  onResetFilters: () => void;
}

function QrcodeFilters({ filters, onFilterChange, onResetFilters }: QrcodeFiltersProps) {
  const [localFilters, setLocalFilters] = React.useState<QrcodeFiltersType>({
    ...filters,
  });

  const handleLocalFilterChange = (name: string, value: string) => {
    setLocalFilters(prev => ({
      ...prev,
      [name]: value || undefined,
    }));
  };

  const handleApplyFilters = () => {
    onFilterChange({
      ...localFilters,
      page: 1, // Reset to first page when filters change
    });
  };

  const hasActiveFilters = Object.keys(filters).some(
    key => key !== 'page' && key !== 'limit' && filters[key as keyof QrcodeFiltersType]
  );

  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <FormField>
          <FormLabel htmlFor="promotion_name">Promoção</FormLabel>
          <FormInput
            id="promotion_name"
            name="promotion_name"
            value={localFilters.promotion_name || ''}
            onChange={e => handleLocalFilterChange('promotion_name', e.target.value)}
            placeholder="Buscar por promoção..."
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="company_name">Empresa</FormLabel>
          <FormInput
            id="company_name"
            name="company_name"
            value={localFilters.company_name || ''}
            onChange={e => handleLocalFilterChange('company_name', e.target.value)}
            placeholder="Buscar por empresa..."
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="send">Status</FormLabel>
          <FormSelect
            id="send"
            name="send"
            value={localFilters.send || ''}
            onChange={e => handleLocalFilterChange('send', e.target.value)}
          >
            <option value="">Todos</option>
            <option value="true">Enviado</option>
            <option value="false">Pendente</option>
          </FormSelect>
        </FormField>
      </div>

      <div className="flex justify-end mt-4 space-x-2">
        {hasActiveFilters && (
          <Button variant="secondary" onClick={onResetFilters} className="flex items-center">
            <X className="h-4 w-4 mr-2" />
            Limpar Filtros
          </Button>
        )}
        <Button onClick={handleApplyFilters} className="flex items-center">
          <Search className="h-4 w-4 mr-2" />
          Filtrar
        </Button>
      </div>
    </div>
  );
}

export default QrcodeFilters;
